
import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Control } from "react-hook-form";

type InvoiceToggleProps = {
  control: Control<any>;
};

const InvoiceToggle: React.FC<InvoiceToggleProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="hasInvoice"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <FormLabel className="text-sm text-foreground">Fatura Durumu</FormLabel>
            <div className="text-xs text-muted-foreground">
              Masrafa ait resmi fatura var mı?
            </div>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
              aria-readonly
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InvoiceToggle;
